var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDriveType(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "cu71a",
    d: "M686.6 955.3c-.1-.1-.1-.3-.1-.45A12.02 12.02 0 0 1 698 946c5.35 0 10.05 3.65 11.5 8.85.05.15 0 .3-.1.45-.1.15-.25.2-.4.2h-22a.45.45 0 0 1-.4-.2zm1.05-.8h20.65A10.9 10.9 0 0 0 698 947c-4.65 0-8.85 3.05-10.35 7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cu71b",
    d: "M709.9 958.05v.6c0 2-.5 3.25-1.4 5 0 .1-.15.2-.35.2h-.1c-1.6-.4-2.7-1.8-2.7-3.4 0-1.8 1.35-2.9 3.5-2.9.2 0 .45 0 .65.05.25.05.4.25.4.45zm-.85.4c-.1.05-.15.05-.15.05-.75 0-2.5.2-2.5 1.9 0 1.05.6 1.95 1.55 2.3.7-1.4 1.1-2.5 1.1-4.15v-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cu71c",
    d: "M705.15 967c.15.2.1.55-.1.7-2.1 1.5-4.55 2.3-7.05 2.3-2.55 0-4.95-.8-7-2.3-.2-.15-.25-.45-.1-.7 1.2-1.75 4-2.85 7.15-2.85 3.1 0 5.9 1.1 7.1 2.85zm-1.15.2c-1.15-1.25-3.5-2.05-6-2.05s-4.8.8-6 2.05a10.7 10.7 0 0 0 6 1.8c2.15 0 4.2-.6 6-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cu71d",
    d: "M713 958c0 8.25-6.75 15-15 15s-15-6.75-15-15 6.75-15 15-15 15 6.75 15 15zm-1 0c0-7.7-6.3-14-14-14s-14 6.3-14 14 6.3 14 14 14 14-6.3 14-14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cu71e",
    d: "M690.55 960.4c0 1.6-1.1 3-2.7 3.4.1.05.05.05 0 .05-.2 0-.35-.1-.45-.25-.9-1.75-1.4-3.65-1.4-5.6v-.6c0-.25.2-.4.4-.45.2-.05.45-.05.65-.05 1.95 0 3.5 1.6 3.5 3.5zm-.9.05c0-1.45-1.2-2.6-2.65-2.55v.1c0 1.65.35 3.25 1.1 4.75a2.5 2.5 0 0 0 1.55-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cu71f",
    d: "M698 957c2.85 0 5 1.05 5 2.5s-2.15 2.5-5 2.5-5-1.05-5-2.5 2.15-2.5 5-2.5zm0 1c-2.45 0-4 .9-4 1.5s1.55 1.5 4 1.5 4-.9 4-1.5-1.55-1.5-4-1.5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-683 -943)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#cu71a"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-683 -943)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#cu71b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-683 -943)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#cu71c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-683 -943)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#cu71d"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-683 -943)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#cu71e"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-683 -943)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#cu71f"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriveType);
export default __webpack_public_path__ + "static/media/drive-type.e584148b58704857ec54bcf3610c468c.svg";
export { ForwardRef as ReactComponent };